import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {CouponListWrapper} from './coupon-list/CouponList'
import AddCoupon from './coupon-form/AddCoupon'
import EditCoupon from './coupon-form/EditCoupon'
import {QueryRequestProvider} from './coupon-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './coupon-list/core/QueryResponseProvider'
import {ListViewProvider} from './coupon-list/core/ListViewProvider'
import {ContextProvider} from './coupon-list/ContextProvider'
import {useContext} from 'react'
import {AlertContext} from '../../../../_metronic/layout/components/alert-context'
import {AlertBox} from '../../../../_metronic/layout/components/alert-message'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Coupon Management',
    path: '/coupon',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const AlertDisplay = () => {
  const {show, message, type} = useContext(AlertContext)
  return <>{show && <AlertBox type={type == '1' ? 'success' : 'error'} message={message} />}</>
}

const CouponPage = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <ContextProvider>
            <AlertDisplay />
            <Routes>
              <Route element={<Outlet />}>
                <Route
                  path='list'
                  element={
                    <>
                      <PageTitle breadcrumbs={usersBreadcrumbs}>Coupon Management</PageTitle>
                      <CouponListWrapper />
                    </>
                  }
                />
                <Route
                  path='add'
                  element={
                    <>
                      <PageTitle breadcrumbs={usersBreadcrumbs}>Add Coupon</PageTitle>
                      <AddCoupon />
                    </>
                  }
                />
                <Route
                  path='edit/:id'
                  element={
                    <>
                      <PageTitle breadcrumbs={usersBreadcrumbs}>Edit Coupon</PageTitle>
                      <EditCoupon />
                    </>
                  }
                />
              </Route>
              <Route index element={<Navigate to='list' />} />
            </Routes>
          </ContextProvider>
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export default CouponPage
